const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.username,
  uid: state => state.user.uid,
  roleCode: state => state.user.roleCode,
  userInfoElse: state => {
    return {
      nickName: state.user.nickName,
      email: state.user.email,
      gender: state.user.gender,
      address: state.user.address,
      mobile: state.user.mobile
    }
  },
  permission_routes: state => state.user.routes,
  permissions: state=>state.user.permissions
  // project_routes: state => state.user.routesProject
}
export default getters
